import { useContext } from "react";

import { PortalTypeContext } from "logging/PortalTypeContext";

const usePortalType = () => {
  const portalType = useContext(PortalTypeContext);

  return portalType;
};

export default usePortalType;
